<template>
  <div  v-redirect-if-no-permission:SPECIAL_EVENTS>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/special_events/store">{{ $t("communication.specialEvents.new") }}</v-btn>
    <DataTable ref="reserDataTable" :disableSearch="false" :sortable="true" :url="'special-event'" :titles="titles"
      :fields-hidden-main="['updated_at', 'deleted_at']"
      :title="$t('communication.specialEvents.title')" :enableEdit="false" :enableAdd="false" :enableDelete="false" :formatter="formatter"
      :actions-extra-main="actionsExtraMain" />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";

export default {
  name: "SpecialEvents",
  title() {
    return this.$t("communication.specialEvents.title");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    formatter() {
      return {
        created_at(value) {
          if(!value) return "";
          return moment(value).format("DD-MM-YYYY - HH:mm");
        },
        from(value) {
          if(!value) return "";
          return moment(value).format("DD-MM-YYYY - HH:mm");
        },
        to(value) {
          if(!value) return "";
          return moment(value).format("DD-MM-YYYY - HH:mm");
        },
      }
    },
    titles() {
      return {
        id: this.$t("communication.specialEvents.id"),
        name: this.$t("common.name"),
        from: this.$t("communication.specialEvents.startTime"),
        to: this.$t("communication.specialEvents.endTime"),
        created_at: this.$t("communication.specialEvents.creationTime")
      };
    },
    actionsExtraMain() {
      return {
        edit: {
          title: this.$t("common.edit"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "edit_special_events",
              params: { id: item.id },
            }),
        },
        delete: {
          title: this.$t("common.delete"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.deleteSpecialEvent(id)
          },
        },
      };
    },
  },
  methods: {
    deleteSpecialEvent(id) {
      this.$dialova({
        title: this.$t("communication.specialEvents.deletingItem", { id }),
        paragraph: this.$t("communication.specialEvents.deleteConfirm", { id }),
        loader: true,
      })
        .then(({ close }) => {

          this.axios
            .delete(`special-event/${id}`)
            .then((res) => {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("communication.specialEvents.deletedSuccessfully"),
                "green"
              );
              this.$refs.reserDataTable.getData();
            })
            .catch((err) => {
              let response = err.response;
              if (response) {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  response.data.message,
                  "red"
                );
              } else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("communication.specialEvents.somethingWentWrong"),
                  "red"
                );
              }
            })
            .finally(() => (close()));
        })
        .catch(() => {
          console.log("cancelled");
        });
    },

  }
};
</script>
